import { AdminRoutePath, RoutePath } from '../../constants';

/**
 * Checks if the current pathname is within the admin portal
 * @param pathname - The pathname to check
 * @returns true if the pathname starts with /admin
 */
export const isAdminRoute = (pathname: string): boolean => pathname.slice(0, 6) === RoutePath.ADMIN;

/**
 * Checks if the current pathname is the client reporting portal (admin interface)
 * @param pathname - The pathname to check
 * @returns true if the pathname is in admin portal AND includes client-reporting-portal
 */
export const isClientReportingPortalRoute = (pathname: string): boolean =>
  isAdminRoute(pathname) && pathname.includes(AdminRoutePath.CLIENT_REPORTING_PORTAL);
